// Pre-built Safe Dig Indiana pathway templates.
//
// The dashboard offers these in a gallery; picking one navigates to the builder
// with ?template=<id> so the builder can pre-fill title, subtitle and pathway
// type.
//
// Ported from Project GLAD's gladPathwayTemplates.js. GLAD's "track"
// (excavator / locator / municipal…) was dropped: Safe Dig's audience is the
// pathway type — Homeowner, Professional or Both — which is what sign-up
// auto-assignment uses, so a second, decorative label only confused things.

export const SAFEDIG_PATHWAY_TEMPLATES = [
  {
    id: 'blank',
    name: 'Blank pathway',
    description: 'Start from a clean canvas. Add your own modules and unlock rules.',
    title: '',
    subtitle: '',
    duration: '—',
    moduleHint: 'No modules — bring your own',
    accent: 'gray',
    icon: 'plus',
  },
  {
    id: 'excavator-essentials',
    name: 'Excavator Essentials',
    description: 'Core safe-digging practice for crews working around buried utilities.',
    classification: 'professional',
    title: 'Excavator Essentials',
    subtitle: 'Safe digging practice around buried utilities',
    duration: '~3 hrs',
    moduleHint: '5 starter modules',
    accent: 'blue',
    icon: 'book',
  },
  {
    id: 'locator-certification',
    name: 'Utility Locator Certification',
    description: 'Preparation for locators marking and documenting underground facilities.',
    classification: 'professional',
    title: 'Utility Locator Certification',
    subtitle: 'Marking and documenting underground facilities',
    duration: '~6 hrs',
    moduleHint: '8 starter modules',
    accent: 'green',
    icon: 'award',
  },
  {
    id: 'damage-prevention',
    name: 'Damage Prevention Cycle',
    description: 'For supervisors running damage-prevention programs on their sites.',
    classification: 'professional',
    title: 'Damage Prevention Cycle',
    subtitle: 'A six-week cycle for site supervisors',
    duration: '~4 hrs',
    moduleHint: '6 starter modules',
    accent: 'amber',
    icon: 'users',
  },
  {
    id: 'homeowner-basics',
    name: 'Homeowner Dig Basics',
    description: 'Short introduction for homeowners planning a project that breaks ground.',
    classification: 'homeowner',
    title: 'Homeowner Dig Basics',
    subtitle: 'What to do before you break ground',
    duration: '~1 hr',
    moduleHint: '4 starter modules',
    accent: 'teal',
    icon: 'sparkles',
  },
  {
    id: 'municipal-leadership',
    name: 'Municipal Program Leadership',
    description: 'For county and municipal leaders rolling out safe-dig practice across crews.',
    classification: 'professional',
    title: 'Municipal Program Leadership',
    subtitle: 'Rolling out safe-dig practice across crews',
    duration: '~3 hrs',
    moduleHint: '5 starter modules',
    accent: 'navy',
    icon: 'compass',
  },
];

/**
 * Who a pathway is for. Same vocabulary as the sign-up selector
 * (tbl_employee.safedig_user_type) and tbl_course.classification. At sign-up,
 * published pathways matching the user's choice are assigned automatically;
 * "both" matches every user, and an unclassified pathway matches no one.
 */
export const SAFEDIG_PATHWAY_CLASSIFICATIONS = [
  { value: 'homeowner', label: 'Homeowner', hint: 'Auto-assigned to homeowners, and to users who chose both' },
  { value: 'professional', label: 'Professional', hint: 'Auto-assigned to professionals, and to users who chose both' },
  { value: 'both', label: 'Both', hint: 'Auto-assigned to every new user' },
];

export function safeDigClassificationLabel(value) {
  const found = SAFEDIG_PATHWAY_CLASSIFICATIONS.find(c => c.value === value);
  return found ? found.label : '';
}

export function getSafeDigTemplate(id) {
  return SAFEDIG_PATHWAY_TEMPLATES.find(t => t.id === id) || null;
}
